export enum AgentLicenseProvider {
  faithlife = 'faithlife',
}

export type AgentLicenseAuthorizationHeader = {
  token: string;
  type: string;
};

export type AgentLicenseValidationClientConfig = {
  providerName: string;
  licenseUrl: string;
  authorizationHeader: AgentLicenseAuthorizationHeader;
};

export type AgentLicenseProperties = {
  jurisdiction: string;
  expirationDate: string;
  licenseType: string;
};

export enum AgentLicenseStatus {
  active = 'active',
  expired = 'expired',
}

export enum AgentLicenseVerificationStatus {
  valid = 'valid',
  expired = 'expired',
  invalidJurisdiction = 'invalidJurisdiction',
  neutral = 'neutral',
}

export type LicensesTableRowData = {
  stateOrProvince: string;
  expirationDate: string;
  licenseType: string;
  status: AgentLicenseStatus;
  id: number;
};
